export default {
  maximumDryDensity: {
    genericReducedProctor: '110121',
    genericReducedLaboratoryDensity: '110122',
  },
  HandShearVane: {
    InHouseMethod: '110465',
  },
  DynamicConePenetrometer: {
    InHouseMethod: '110470',
  },
  AsphaltNuclearFieldDensity: {
    InHouseMethod: '117311',
  },
  EquivalentCBRByPlateLoading: {
    InHouseMethod: '110471',
  },
  SamplingCertificate: {
    BS_EN_932_1_Rev1997: '115000',
    BS_5930_Rev2015: '115002',
  },
};
